import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'

type Props = {
  isSaving: boolean
  lastSavedAt: Date | null
}

export function AutoSaveIndicator({ isSaving, lastSavedAt }: Props) {
  const [label, setLabel] = useState<string>('')

  useEffect(() => {
    if (!lastSavedAt) return

    const computeLabel = () => {
      const diffMs = Date.now() - lastSavedAt.getTime()
      if (diffMs < 60_000) {
        setLabel('Sauvegardé il y a quelques secondes')
      } else {
        setLabel(`Sauvegardé il y a ${Math.floor(diffMs / 60_000)} min`)
      }
    }

    computeLabel()
    const interval = setInterval(computeLabel, 30_000)
    return () => clearInterval(interval)
  }, [lastSavedAt])

  // Conteneur aria-live TOUJOURS dans le DOM (UX-4) — les screen readers ignorent le
  // contenu initial d'un nœud aria-live ajouté dynamiquement. En maintenant le conteneur
  // présent dès le montage, seuls les changements de contenu déclenchent une annonce.
  return (
    <div aria-live="polite" aria-atomic="true" className="text-xs text-muted-foreground flex items-center gap-1 min-h-[1rem]">
      {isSaving ? (
        <>
          <Loader2 className="w-3 h-3 animate-spin" />
          Sauvegarde en cours...
        </>
      ) : lastSavedAt !== null ? (
        label
      ) : null}
    </div>
  )
}
